import application from './application';
import page from './page';
import article from './article';
import email from './email';
import event from './event';
import book from './book';

export default {
  ...application,
  ...page,
  ...article,
  ...email,
  ...event,
  ...book,
};
